import localeData from '@wix/locale-dataset-javascript';

export const getCountriesData = () =>
  localeData.getAllCountries().map((country) => ({
    displayName: country.displayName,
    key: country.shortKey!,
    states:
      country.subdivisions && country.subdivisions.type === 'state'
        ? country.subdivisions.list
        : [],
  }));
